/* two-column-layout.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./two-column-layout.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { DynamicLayoutComponent } from '../../component/dynamic-layout-component';
var styles = {
  leftColumnStyles: "_1bsb1osq",
  rightColumnStyles: "_1bsbaq3k"
};
var REQUIRED_ELEMENTS_COUNT = 1;
export var TwoColumnLayout = function TwoColumnLayout(_ref) {
  var elements = _ref.elements,
    key = _ref.key;
  if (elements.length < REQUIRED_ELEMENTS_COUNT) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Inline, {
    space: "space.200"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.leftColumnStyles
  }, elements.map(function (element) {
    var _element$attributes, _element$attributes2;
    return typeof element !== 'string' && ((_element$attributes = element.attributes) === null || _element$attributes === void 0 ? void 0 : _element$attributes.pos) === 'left' && /*#__PURE__*/React.createElement(DynamicLayoutComponent, {
      component: element,
      position: "two-columns-left",
      key: "".concat(key, "-").concat((_element$attributes2 = element.attributes) === null || _element$attributes2 === void 0 ? void 0 : _element$attributes2.pos)
    });
  })), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.rightColumnStyles
  }, elements.map(function (element) {
    var _element$attributes3, _element$attributes4;
    return typeof element !== 'string' && ((_element$attributes3 = element.attributes) === null || _element$attributes3 === void 0 ? void 0 : _element$attributes3.pos) === 'right' && /*#__PURE__*/React.createElement(DynamicLayoutComponent, {
      component: element,
      position: "two-columns-right",
      key: "".concat(key, "-").concat((_element$attributes4 = element.attributes) === null || _element$attributes4 === void 0 ? void 0 : _element$attributes4.pos)
    });
  })));
};